module.exports = __webpack_public_path__ + "img/3.278f7381.jpg";